import React from "react";
import HomeComponent from "../../components/HomeComponent/home";
import "../../assets/css/animate.min.css";

type Props = {
  history: any;
  location: any;
};

const HomePage = ({ history, location }: Props) => {
  const token: string | null = localStorage.getItem("token");

  return <HomeComponent history={history} location={location} token={token} />;
};
export default HomePage;
